<template>
    <div class="container-sm registration-form">
        <BlockUI :message="msg" v-show="isLoading">
            <div class="fa-3x">
                <i class="fas fa-spinner fa-spin lightgreen"></i>
            </div>
        </BlockUI>
        <transition name="animate-loading-transition" enter-active-class="animate__animated animate__backInUp" leave-active-class="animate__animated animate__backOutDown">
            <div v-if="isShowThankYou">
                <div class="text-center mb-4 mt-4">
                    <h1 class="h3 mb-3 font-weight-normal">Email Validation</h1>
                    <p>We have sent you an email which includes a verification link.</p>
                    <p>Please click the link to complete the registration. <br/>Please check your spam folder if you could not find the email in your inbox folder.</p>
                </div>
            </div>
            <div class="d-flex justify-content-center" v-else>
                <div class="row w-50">
                    <div class="text-left mb-1 mt-4">
                        <h1 class="h3 font-weight-normal">Email Validation</h1>
                        <p>*Required</p>
                    </div>
                    <div class="form-label-group mb-3">
                        <label for="company_name" class="form-label text-uppercase fw-bold">Registered Business Name*</label>
                        <input type="text" id="company_name" v-model="company_name" class="form-control text-capitalize" :class="{ 'is-invalid': $v.company_name.$error }" maxlength="150" placeholder="Your complete company name" autofocus>
                        <transition enter-active-class="animate__animated animate__slideInUp" leave-active-class="animate__animated animate__fadeOut">
                            <div v-if="$v.company_name.$error">
                                <div class="fw-light invalid-feedback d-block" v-if="!$v.company_name.required">Registered company name is required.</div>
                            </div>
                        </transition>
                    </div>
                    <div class="form-label-group mb-3">
                        <label for="ref_email" class="form-label text-uppercase fw-bold">E-mail Address*</label>
                        <input type="email" id="ref_email" v-model="ref_email" class="form-control text-lowercase" :class="isEmailInvalid" placeholder="emailaddress@domain.com" @blur="doCheckEmail" maxlength="200">
                        <transition enter-active-class="animate__animated animate__slideInUp" leave-active-class="animate__animated animate__fadeOut">
                            <div v-if="$v.ref_email.$pending || ref_email_error_pending" class="text-info mt-1">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                <span class="fs-12">Checking e-mail address. Please wait...</span>
                            </div>
                            <div class="fw-light invalid-feedback d-block" v-if="ref_email_error">Company email is already used.</div>
                            <div v-if="$v.ref_email.$error">
                                <div class="fw-light invalid-feedback d-block" v-if="!$v.ref_email.required">E-mail address is required.</div>
                                <div class="fw-light invalid-feedback d-block" v-if="!$v.ref_email.email">E-mail address is invalid format.</div>
                            </div>
                        </transition>
                    </div>
                    <div class="d-grid gap-2 col-8 mx-auto">
                        <div class="link-border">
                            <a @click="doValidate" role="button" class="lightgreen_btn text-center" :disabled="$v.$pending">SEND VALIDATION EMAIL</a>
                        </div>
                    </div>
                    <div class="row justify-content-center pb-5">
                        <div class="col-12 text-center">
                            <div class="form-check form-check-inline mb-3">
                                <input class="form-check-input" type="checkbox" :class="{ 'is-invalid': $v.agree_terms.$error }" :value="1" v-model="agree_terms" id="agree" @change="$v.agree_terms.$touch">
                                <label class="form-check-label align-middle" for="agree">I have read and agree to the <a href="javascript:;" data-bs-toggle="modal" data-bs-target="#terms" class="lightgreen">Terms and Conditions</a></label>
                                <transition enter-active-class="animate__animated animate__slideInUp" leave-active-class="animate__animated animate__fadeOut">
                                    <div v-if="$v.agree_terms.$error">
                                        <div class="fw-light invalid-feedback d-block" v-if="!$v.agree_terms.checked">Please agree with the terms and conditions.</div>
                                    </div>
                                </transition>
                            </div>
                        </div>    
                    </div>
                </div>
            </div>    
        </transition>    

        <div class="modal fade" id="terms" tabindex="-1" aria-labelledby="" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header lightgreen-bg">
                        <h4 class="modal-title text-uppercase text-white">Terms and Conditions</h4>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="row g-1">
                            <div class="col">
                                <p>By clicking "Submit", I hereby consent DTI-CITEM to use and process all data in this Application Form for any purpose related to SSX or the conduct of DTI-CITEM's business, including, but not limited to, promotion of relevant products and services by email, in accordance with the requirements of trade promotion and Republic Act No. 10173 otherwise known as the Data Privacy Act of 2012.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Vuelidate from 'vuelidate'
    import { required, email } from 'vuelidate/lib/validators'
    import BlockUI from 'vue-blockui'

    Vue.use(Vuelidate)
    Vue.use(BlockUI)

    export default {
        data() {
            return {
                isLoading: false,
                isShowThankYou: false,
                msg: 'Saving record. Please wait...',
                company_name: '',
                ref_email: '',
                ref_email_error_pending: false,
                ref_email_error: false,
                agree_terms: false,
            }
        },
        validations: {  
            company_name: { required },
            ref_email: { required, email },
            agree_terms: {
                checked (val) {
                    if (val === '') return true
                    return val
                }
            }
        },
        mounted() {
            //console.log('Component mounted.')
        },
        computed: {
            isEmailInvalid() {
                return {
                    'is-invalid': this.$v.ref_email.$error || this.ref_email_error
                }
            }
        },
        methods: {
            doCheckEmail() {
                this.ref_email_error_pending = true
                axios.get('/api/check-company-email-unique/'+this.ref_email+'/buyer')
                .then(response => {
                    if (response.status === 200) {
                        if (response.data === false) {
                            this.ref_email_error = true
                        } else {
                            this.ref_email_error = false
                        }
                        this.ref_email_error_pending = false
                    }
                })
            },
            doValidate() {
                this.$v.$touch()
                if (!this.$v.$invalid && !this.$v.$pending && !this.ref_email_error && !this.ref_email_error_pending) {
                    this.isLoading = true
                    let formData = new FormData()
                    formData.append('company_name', this.company_name)
                    formData.append('ref_email', this.ref_email)
                    axios.post('/registration/purchaser/email-validation', formData)
                    .then(response => {
                        //console.log(response.data);
                        if (response.status === 200) {
                            this.isLoading = false
                            this.isShowThankYou = true
                        }
                    }).catch(err => {
                        console.log(err)
                    })
                }
            }
        }
    }
</script>
